var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layer", { staticClass: "opt_more_g", attrs: { name: "move" } }, [
    _c(
      "div",
      { staticClass: "box_opt_menu opt_menu_board" },
      _vm._l(_vm.boards, function ({ fldid, fldname }) {
        return _c("div", { staticClass: "menu_item" }, [
          _c(
            "a",
            {
              staticClass: "link_menu",
              attrs: { href: "javascript:" },
              on: {
                click: function ($event) {
                  return _vm.callback(fldid)
                },
              },
            },
            [_vm._v(_vm._s(fldname))]
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }